const React = require("react");
const Main = require("./src/layouts/Main").default;

// Wraps every page in a component
exports.wrapPageElement = ({ element, props }) => {
  return <Main {...props}>{element}</Main>;
};
